<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Ajout d'un utilisateur</h1>
                <div class="pageOptions">
                    <btn text="Enregistrer" ico="valide" @click="save"
                         v-if="$store.getters.hasPerm('user:add/edit')"></btn>
                    <btn ico="times" color="red" @click="cancel" v-if="$store.getters.hasPerm('user:add/edit')"></btn>
                </div>
            </div>
        </div>
        <form class="" action="" method="post">
            <div class="line">
                <div class="medium">
                    <label for="nom">Nom</label>
                    <input type="text" v-model="user.lastname" id="nom">
                </div>
                <div class="medium">
                    <label for="prenom">Prénom</label>
                    <input type="text" v-model="user.firstname" id="prenom">
                </div>
            </div>
            <div class="line">
                <div class="medium">
                    <label for="nomUtilisateur">Nom d'utilisateur</label>
                    <input type="text" v-model="user.login" id="nomUtilisateur">
                </div>
                <div class="medium">
                    <div class="passwordView">
                        <label for="mdp">Mot de passe</label>
                        <svg @mousedown="togglePassword(1)" @mouseup="togglePassword(0)" @mouseout="togglePassword(0)">
                            <use xlink:href="#icon-eye"></use>
                        </svg>
                    </div>
                    <input :type="passwordType" v-model="user.password" id="mdp">
                </div>
            </div>
            <div>
                <label class="medium">
                    Droite de l'utilisateur
                </label>
                <model-list-select v-model="user.group_id"
                                   :list="groups"
                                   option-value="id"
                                   option-text="label"
                                   placeholder="Sélectionner un groupe">
                </model-list-select>
            </div>
        </form>

    </div>
</template>

<script>

    import Btn from "@/components/Btn";
    import {ModelListSelect} from 'vue-search-select';
    import Loader from "@/components/Loader";
    import axios from 'axios';
    import tools from '../config.ts';

    export default {
        name: "User",
        components: {Btn, ModelListSelect, Loader},
        data() {
            return {
                userId: 0,
                user: {},
                groups: [],

                passwordType: "password",

            }
        },
        methods: {
            load() {

                if (!this.userId) {
                    tools.loader(false);
                    return;
                }

                axios.get(tools.api("user/" + this.userId), tools.headerGET())
                    .then((response) => {
                        this.user = response.data;
                        tools.loader(false);
                    })
            },
            save() {

                let url = "user";
                let active = 1;
                if (this.userId) {
                    url += "/" + this.userId;
                    active = this.user.active;
                }

                tools.loader(true);
                axios.post(tools.api(url), tools.toPOST({
                    id: this.userId,
                    login: this.user.login,
                    password: this.user.password,
                    firstname: this.user.firstname,
                    lastname: this.user.lastname,
                    group_id: this.user.group_id,
                    active: active
                }), tools.headerPOST())
                    .then((response) => {
                        tools.loader(false);
                        if (!tools.isSuccessResponse(response)) {
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de l'enregistrement de l'utilisateur",
                            });
                        }
                        this.$router.push("/users")
                    })
                    .catch((error) => {
                        tools.loader(false);
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de l'enregistrement de l'utilisateur. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })

            },
            cancel() {
                tools.popup("confirm", {
                    title: "Confirmation",
                    message: "Voulez-vous vraiment annuler les modifications ?",
                    success: () => {
                        this.$router.push("/users");
                    }
                })
            },

            togglePassword(toggle) {
                this.passwordType = toggle ? 'input' : 'password'
            },
        },
        mounted() {

            if (!this.$store.getters.hasPerm('user:add/edit')) {
                return this.$router.back();
            }

            tools.loader(true);
            this.$store.commit("onEditMode", true);

            this.userId = this.$route.params.id;

            this.load();

            axios.get(tools.api("groups"), tools.headerGET())
                .then((response) => {
                    this.groups = response.data
                })
        }
    }
</script>